/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllScreenerSourcesRequest
 */
export interface FindAllScreenerSourcesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FindAllScreenerSourcesRequest
     */
    source_id?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FindAllScreenerSourcesRequest
     */
    search?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindAllScreenerSourcesRequest
     */
    type?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindAllScreenerSourcesRequest
     */
    tag_id?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FindAllScreenerSourcesRequest
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllScreenerSourcesRequest
     */
    page?: number;
}

/**
 * Check if a given object implements the FindAllScreenerSourcesRequest interface.
 */
export function instanceOfFindAllScreenerSourcesRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerSourcesRequestFromJSON(json: any): FindAllScreenerSourcesRequest {
    return FindAllScreenerSourcesRequestFromJSONTyped(json, false);
}

export function FindAllScreenerSourcesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerSourcesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source_id': !exists(json, 'source_id') ? undefined : json['source_id'],
        'search': !exists(json, 'search') ? undefined : json['search'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'tag_id': !exists(json, 'tag_id') ? undefined : json['tag_id'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'page': !exists(json, 'page') ? undefined : json['page'],
    };
}

export function FindAllScreenerSourcesRequestToJSON(value?: FindAllScreenerSourcesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_id': value.source_id,
        'search': value.search,
        'type': value.type,
        'tag_id': value.tag_id,
        'limit': value.limit,
        'page': value.page,
    };
}

